export default {
  name: "navHeader"
};